import React, {useEffect, useRef} from "react";

import styles from "./Graph.module.scss";
import gsap from "gsap";
import {isInViewport} from "../../Functions";


export default function CompanyAttack () {
    const element = useRef(null);

    useEffect(() => {
        const bars = element.current.querySelectorAll('.bar-wrapper rect');
        const texts = element.current.querySelectorAll('.bar-wrapper text:first-child');

        gsap.set(bars, {
            attr: {
                transform: 'scale(0, 1)'
            }
        });

        gsap.set(texts, {
            opacity: 0
        });

        if (element.current && !element.current.classList.contains('animated')) {
            window.addEventListener('scroll', () => {
                if (isInViewport(element.current)) {

                    Object.values(bars).map((bar, index) =>
                        gsap.to(bar, .6, {
                            transform: 'scale(1, 1)',
                            delay: .2 * index,
                            onComplete: () => {
                                gsap.to(texts[index], .3, {
                                    opacity: 1
                                })
                            }
                        })
                    );

                    element.current.classList.add('animated');
                }
            })
        }


    }, []);

    const svg = `
<svg width="1136px" height="398px" viewBox="0 0 1136 398" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g  stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g  transform="translate(-25.000000, 0.000000)">
            <g  transform="translate(186.000000, 0.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Bold, Open Sans" font-size="16" font-weight="bold" fill="#000000">
                    <tspan x="754" y="18">73 %  </tspan>
                    <tspan x="799.148438" y="18" font-family="OpenSans-LightItalic, Open Sans Light" font-size="13" font-style="italic" font-weight="normal">Rappel Vague 6 : 80%</tspan>
                </text>
                <text  font-family="OpenSans-Bold, Open Sans" font-size="13" font-weight="bold" fill="#000000">
                    <tspan x="0.0170898438" y="17">Phishing ou spear phishing</tspan>
                </text>
                <rect  fill="#5947CA" x="184" y="0" width="560" height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(84.000000, 28.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="704" y="22">53 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="127.915527" y="13.3779297">Exploitation d’une faille</tspan>
                    <tspan x="19.0361328" y="29" font-size="11">(vulnérabilité logicielle ou défaut de configuration)</tspan>
                </text>
                <rect  fill="#5947CA" x="286" y="6" width="408" height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(181.000000, 67.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="607" y="17">38 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="40.0244141" y="15.3779297">Arnaque au président</tspan>
                </text>
                <rect  fill="#5947CA" x="189" y="1" width="408"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(91.000000, 101.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="582" y="17">34 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="18.4443359" y="15.3779297">Tentatives de connexion</tspan>
                    <tspan x="166.949219" y="16" font-size="11"> (brute force, etc…)</tspan>
                </text>
                <rect  fill="#5947CA" x="279" y="1" width="293"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(0.000000, 135.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="620" y="17">31 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="83.5405273" y="15.3779297">Acquisition de noms de domaines illégitimes</tspan>
                </text>
                <rect  fill="#5947CA" x="370" y="1" width="240"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(0.000000, 169.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="574" y="17">25 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="192.32666" y="15.3779297">Attaque en déni de service</tspan>
                </text>
                <rect  fill="#5947CA" x="370" y="1" width="194"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(0.000000, 203.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="543" y="17">21 %  </tspan>
                    <tspan x="586.9375" y="17" font-family="OpenSans-LightItalic, Open Sans Light" font-size="13" font-style="italic">Rappel Vague 5 : 16%</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="67.3730469" y="15.3779297">Attaque indirecte par rebond via un prestataire </tspan>
                </text>
                <rect  fill="#5947CA" x="370" y="1" width="163"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(0.000000, 232.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="535" y="22">20 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="17.6328125" y="13.3779297">Exfiltration et/ou divulgation volontaire de données par </tspan>
                    <tspan x="123.949707" y="28.3779297">une personne ayant un accès légitime</tspan>
                </text>
                <rect  fill="#5947CA" x="370" y="6" width="155"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(0.000000, 271.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="497" y="17">15 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="160.728027" y="15.3779297">Autre forme d’ingénierie sociale</tspan>
                </text>
                <rect  fill="#5947CA" x="370" y="1" width="117"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(0.000000, 305.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="429" y="17">6 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="60.3969727" y="15.3779297">Usage abusif d’outils (administration, support… )</tspan>
                </text>
                <rect  fill="#5947CA" x="370" y="1" width="49"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(0.000000, 339.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="414" y="17">4 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="239.45166" y="15.3779297">Intrusion physique</tspan>
                </text>
                <rect  fill="#5947CA" x="370" y="1" width="34"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(0.000000, 373.000000)" class="bar-wrapper">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" fill="#000000">
                    <tspan x="414" y="17">5 %</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="13" font-weight="normal" line-spacing="15" fill="#000000">
                    <tspan x="184.106445" y="15.3779297">Autre type de cyber attaque</tspan>
                </text>
                <rect  fill="#9B9B9B" x="370" y="1" width="34"   height="24" style="transform-origin: 0% 0%; transform-box: fill-box;"></rect>
            </g>
            <g  transform="translate(939.000000, 257.000000)">
                <text  font-family="OpenSans-Regular, Open Sans" font-size="16" font-weight="normal" line-spacing="20" fill="#000000">
                    <tspan x="0" y="95">Types d’attaques en moyenne</tspan>
                </text>
                <text  font-family="OpenSans-Regular, Open Sans" font-size="12" font-weight="normal" line-spacing="16" fill="#000000">
                    <tspan x="0" y="114">parmi ceux ayant subi au moins</tspan>
                    <tspan x="0" y="130">une attaque</tspan>
                </text>
                <text  font-family="OpenSans-Bold, Open Sans" font-size="50" font-weight="bold" line-spacing="50" fill="#5947CA">
                    <tspan x="0" y="53">3,3</tspan>
                </text>
                <path d="M0,63.5 L120,63.5"  stroke="#5947CA" stroke-width="3" stroke-linecap="square"></path>
            </g>
        </g>
    </g>
</svg>`;

    return (
        <div className={styles.Mono} ref={element}>
            <div dangerouslySetInnerHTML={{__html: svg}} className={[styles.Graph, styles.Medium].join(' ')}/>
        </div>
    )
}
